<template>
    <div class="dual-view-setting-trigger">
        <ElTooltip
            :visibleArrow="false"
            :content="$t('patent-view.tabSettingDialog.title')"
            :openDelay="POPPER_OPEN_DELAY"
            popperClass="dual-view-setting-trigger__tooltip"
            placement="top"
        >
            <PtIcon class="dual-view-setting-trigger__button" icon="SolidSettings" @click="openSettingDialog" />
        </ElTooltip>
        <DualViewSettingDialog v-if="isShowSettingDialog" @cancel="closeSettingDialog" @submit="closeSettingDialog" />
    </div>
</template>

<script>
import { Icon } from 'patsnap-biz';
import { Tooltip } from 'element-ui';
import DualViewSettingDialog from './DualViewSettingDialog';
import { POPPER_OPEN_DELAY } from '../../constants';
import '@patsnap-ui/icon/assets/solid/settings.svg';

export default {
    name: 'DualViewSettingTrigger',
    components: {
        PtIcon: Icon,
        ElTooltip: Tooltip,
        DualViewSettingDialog,
    },
    data() {
        return {
            isShowSettingDialog: false,
        };
    },
    created() {
        this.POPPER_OPEN_DELAY = POPPER_OPEN_DELAY;
    },
    methods: {
        openSettingDialog() {
            this.isShowSettingDialog = true;
        },
        closeSettingDialog() {
            this.isShowSettingDialog = false;
        },
    },
};
</script>

<style lang="scss">
.dual-view-setting-trigger {
    font-size: 0;
    display: inline-block;
    vertical-align: center;
    .dual-view-setting-trigger__button {
        cursor: pointer;
        border-radius: 4px;
        &:hover {
            background-color: $bg-dark;
        }
    }
}
.dual-view-setting-trigger__tooltip {
    &[x-placement^=top] {
        margin-bottom: 4px;
    }
    &[x-placement^=bottom] {
        margin-top: 4px;
    }
}
</style>
